import React from 'react';
import CheckOrCross from '../Shared/CheckOrCross';

const FEATURE_NAME = 'transcript-dubbing';

const transcriptAudioFeatures = ({ packages }) => ({
  enabled: {
    key: 'transcript-audio-enabled',
    label: 'transcriptAudio',
    values: packages.map((pkg) => (
      <CheckOrCross
        key={pkg.code}
        isCheck={!!pkg?.features?.includes(FEATURE_NAME)}
      />
    )),
  },
});

export default transcriptAudioFeatures;
